import { Component, EventEmitter, Input, OnInit, Output, ViewChildren, QueryList, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { TYPE_SELECTION } from 'src/app/shared/conf/breakdown-scene';
import { Sketchpad } from 'src/assets/js/sketchpad.js';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-breakdown-scene-detail',
    templateUrl: './breakdown-scene-detail.component.html',
    styleUrls: ['./breakdown-scene-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BreakdownSceneDetailComponent implements OnInit {

	@ViewChildren(MatAutocompleteTrigger) MatAutocompleteTrigger: QueryList<MatAutocompleteTrigger>;
	@Input() metadata: any;
	@Input() characters: any [];
	@Input() listCharacters: any[] = [];
	@Input() scene: any;
	@Input() events: any;
	@Input() category_elements: any;
	@Input() dropdowns: any;
	@Input() project_id: any;
	@Input() scene_id: any;
	@Input() showFilterMenu?: boolean = false;
	// TODO: Cuando el backend esté listo, pasar el script_drawing desde el componente padre
	@Input() scriptDrawingData: any = null;

	@Output() addElement = new EventEmitter()
	@Output() onShowContext = new EventEmitter<boolean>();
	@Output() onChangeFullscreen = new EventEmitter<boolean>();

	script: any;
	canShow: boolean = false;
	form: UntypedFormGroup;
	error: string;
	view: string = 'add-face';
	loading: boolean = false;
	selectedType: any;
	filteredCharacters: any = [];
	typeSelection: any[] = TYPE_SELECTION;
	categories = {
		'characters': [],
		'element': [],
		'extra': [],
		'note': [],
		// 'vfx': [],
	}
	filteredCategories = {
		'characters': [],
		'element': [],
		'extra': [],
		'note': [],
		// 'vfx': [],
	}
	options = {
		'characters': [],
		'element': [],
		'extra': [],
		'note': [],
		// 'vfx': [],
	}
	filteredOptions = {
		'characters': [],
		'element': [],
		'extra': [],
		'note': [],
		// 'vfx': [],
	}
	isFullscreen: boolean = false;
	// Drawing variables
	isDrawingMode: boolean = false;
	sketchpad: Sketchpad;
	scriptDrawing: any = null; // Dibujo guardado del script
	color: string = '#000';
	penSize: number = 2;
	loadingDrawing: boolean = false;
	selectedCharacter: any = null;

  validetAloneWord(word, pharagraph) {
    pharagraph = pharagraph.replace(/<[^>]*>?/gm, '')
    let start = pharagraph.toLowerCase().indexOf(word)
    start = start > 0 ? start - 1 : start;

    let end = start + (start == 0 ? word.length + 1 : word.length + 2)
    const extractWord = pharagraph.slice(start, end)

    if (/[()]/g.test(word)) {
      return word.toLowerCase() == extractWord.trim().toLowerCase().replace(/[.,\/#!$%\^&\*;:{}=\-_`~]/g,"")
    }

    return word.toLowerCase() == extractWord.trim().toLowerCase().replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"")

  }

	addSpanToElement(list_elements, element, field, class_element, desgloce?) {
		element.breakdown = element.breakdown ? element.breakdown : element.text
    	list_elements.forEach(cast => {
			const prop = desgloce ? desgloce.value : cast[field].toLowerCase()
			const start = element.breakdown.toLowerCase().indexOf(prop)
			if (this.validetAloneWord(prop, JSON.parse(JSON.stringify(element.breakdown)) )) {
				if (start > -1) {
					const end = start + prop.length
					element.breakdown = element.breakdown.split("")
					element.breakdown.splice(start, 0, `<span class="${class_element}">`)
					element.breakdown.splice(end + 1, 0, '</span>')
					element.breakdown = element.breakdown.join("")
				}
			}
		})
		return element
	}

	breakMetadata() {
		this.script = this.metadata.map(element => {
			element.breakdown = element.text
			let _element;
			this.characters.forEach((character: any) => {
				_element = this.addSpanToElement(character.characters, element, "character_name", "breakdown_characters");
			});
			this.category_elements.forEach(category => {
				_element = this.addSpanToElement(category.elements, element, "element_name", "breakdown_elements")
			})
			this.events.forEach(element => {
				element.search = (`${element.event_full_name_esp.replace(element.name_esp,'').trim()}`)
			})
			_element = this.addSpanToElement(this.events, element, "search", "breakdown_events")
			return _element
		})
	}

	onSelectedText(allowEmptyText = false) {
		let selection = window.getSelection();
		let text = selection.toString().trim();
		if (!text) return

		this.form = new UntypedFormGroup({
			name: new UntypedFormControl(''),
			category_id: new UntypedFormControl(''),
			type: new UntypedFormControl(this.view),
			quantity: new UntypedFormControl(''),

		});

		this.form.patchValue({
			'name': text,
			'category_id': "",
			'quantity': ""

		});
		this._gS.openContextMenu(event);
	}

	setSelectedType() {
		let selected = this.form.get('type').value;
		this.selectedType = this.typeSelection.find(t => t.value == selected);
	}

	displayCategoryName(cat) {
		return cat ? cat.category_name : '';
	}

	/* 	displayOptionName() {
			const that = this;
			return function (name) {
				if (!that.form) return '';
				return name ? (name[that.selectedType.propertyName] ? name[that.selectedType.propertyName] : name) : '';
			}
		}
	 */

	onClickBoxContext($event) {
		$event.stopPropagation();
		this.MatAutocompleteTrigger.map(mat => mat.closePanel());
		this.form.updateValueAndValidity();
	}

	changeCharacter(event) {
		this.form.patchValue({
			'category_id': event
		});
	}

	changeQuantity(event) {
		this.form.patchValue({
			'category_id': event
		});
	}

	changeElement(event) {
		this.form.patchValue({
			'category_id': event
		});
	}

	changeEvent(event) {
		this.form.patchValue({
			'category_id': event
		});
	}

	addComment() {
		var a: any = {
			'comment_id': '',
			'comment': '',
			'user_id': ''
		}
		this.dropdowns.comments.push(a)
	}


	closeMenuTextSelected() {
		this.form.patchValue({
			'category': '',
			'name': ''
		});
		this.form.markAsUntouched();
		this.canShow = false;
		this.onShowContext.emit(this.canShow);
		this._gS.hidemenu();
	}
	changeView(ev, view) {
		ev.stopPropagation();
		this.view = view;
		this.form.patchValue({
			'type': view,
			'category_id': ''
		});

	}

	saveBreakdown(class_element) {
		this._gS.hidemenu();
		if (this.form.value.type == 'add-face') {
			this._pS.sceneAddCharacter(this.project_id, this.scene_id, this.form.value.category_id, this.form.value.name, this.form.value.quantity)
				.subscribe((data) => {
					this.addElement.emit({ name: this.form.value.name, category_id: this.form.value.category_id, type: this.form.value.type, })
					this.script = this.script.map(element => {
						element.breakdown = element.breakdown
						let _element;
						this.characters.forEach((character: any) => {
							_element = this.addSpanToElement(character.characters, element, "character_name", "breakdown_characters");
						});
					return _element
					})
				})
		}
		if (this.form.value.type == 'add-fact_check') {
			this._pS.sceneAddElement(this.project_id, this.scene_id, this.form.value.category_id, this.form.value.name)
				.subscribe((data) => {
					this.addElement.emit({ name: this.form.value.name, category_id: this.form.value.category_id, type: this.form.value.type })

				})
		}
		if (this.form.value.type == 'add-event') {
			this._pS.sceneAddEvent(this.project_id, this.scene_id, this.form.value.category_id, this.form.value.name)
				.subscribe((data) => {
					this.addElement.emit({ name: this.form.value.name, category_id: this.form.value.category_id, type: this.form.value.type })

				})
		}
	}

	toggleFullscreen() {
		this.isFullscreen = !this.isFullscreen;
		this.onChangeFullscreen.emit(this.isFullscreen);
	}

	// Drawing methods
	toggleDrawingMode() {
		this.isDrawingMode = !this.isDrawingMode;
		if (this.isDrawingMode) {
			setTimeout(() => {
				this.initializeSketchpad();
			}, 100);
		}
	}

	initializeSketchpad() {
		const scriptContainer = document.querySelector('.script-container .page');
		if (!scriptContainer) return;
		
		const rect = scriptContainer.getBoundingClientRect();
		
		// Si existe un dibujo guardado, cargarlo
		if (this.scriptDrawing && this.scriptDrawing.json) {
			this.loadScriptDrawing(rect);
		} else {
			// Crear un nuevo sketchpad vacío
			this.sketchpad = new Sketchpad({
				element: '#breakdown-sketchpad',
				height: rect.height,
				width: rect.width,
				penSize: this.penSize
			});
		}
	}

	loadScriptDrawing(rect) {
		try {
			let parsed = JSON.parse(this.scriptDrawing.json);
			parsed.element = '#breakdown-sketchpad';
			parsed.height = rect.height;
			parsed.width = rect.width;
			parsed.penSize = this.penSize;
			this.sketchpad = new Sketchpad(parsed);
		} catch (error) {
			console.error('Error loading script drawing:', error);
			// Si hay error, crear uno nuevo
			this.sketchpad = new Sketchpad({
				element: '#breakdown-sketchpad',
				height: rect.height,
				width: rect.width,
				penSize: this.penSize
			});
		}
	}

	saveDrawing() {
		if (!this.sketchpad) return;
		const note = this.sketchpad.toObject();
		const jsonData = JSON.stringify(note);
		
		// TODO: Conectar con el backend cuando esté listo
		// this._pS.saveScriptDrawing(this.scene_id, jsonData).subscribe({
		//   next: (data) => {
		//     console.log('Drawing saved successfully');
		//     this.scriptDrawing = { json: jsonData };
		//     this.cancelDrawing();
		//   },
		//   error: (err) => {
		//     console.error('Error saving drawing:', err);
		//   }
		// });
		
		console.log('Drawing to save:', jsonData);
		// Guardar temporalmente en memoria hasta que el backend esté listo
		this.scriptDrawing = { json: jsonData };
		this.cancelDrawing();
	}

	clearDrawing() {
		if (!this.sketchpad) return;
		this.sketchpad.clear();
		// Limpiar también la memoria temporal
		this.scriptDrawing = null;
	}

	cancelDrawing() {
		this.isDrawingMode = false;
		this.sketchpad = null;
	}

	constructor(
		public _gS: GlobalService, private _pS: ProjetcsService
	) { }

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges){
    if(changes.metadata && this.metadata.length){
			this.breakMetadata();
    }
		if(changes.scriptDrawingData && this.scriptDrawingData){
			this.scriptDrawing = this.scriptDrawingData;
		}
  }

}
